
export const toSlug = (str) => {
	str = str.replace(/^\s+|\s+$/g, '');
	str = str.toLowerCase();

	const from = 'àáãäâèéëêìíïîòóöôùúüûñç·/_,:;';
	const to = 'aaaaaeeeeiiiioooouuuunc------';
	// eslint-disable-next-line no-plusplus
	for (let i = 0, l = from.length; i < l; i++) {
		str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
	}

	str = str.replace(/[^a-z0-9 -]/g, '')
		.replace(/\s+/g, '-')
		.replace(/-+/g, '-');

	return str;
};

export const toSnake = (str) => {
	let s;
	s = str.replace(/[^\w\s]/g, '');
	s = s.replace(/\s+/g, ' ');
	return s.toLowerCase().split(' ').join('_');
};

const Str = {
	toSlug,
	toSnake,
};

export default Str;
